import { httpService } from '@flexo/general';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { normalizeAppConfig, writeCachedAppConfig } from './storage';

const ENV = (import.meta as any).env;

export const FetchAppConfigAsync = createAsyncThunk(
  'appConfig/FetchAppConfigAsync',
  async () => {
    const params: Record<string, string> = {};

    if (ENV?.VITE_APP_CLERK_ORG_ID) {
      params.clerk_org_id = ENV.VITE_APP_CLERK_ORG_ID;
    }

    if (ENV?.VITE_APP_ORG_ID) {
      params.catalog_org_id = ENV.VITE_APP_ORG_ID;
    }

    if (!params.clerk_org_id && !params.catalog_org_id) {
      return Promise.reject(new Error('Missing organization identifiers for app config'));
    }

    const response = await httpService.get({
      url: '/common/v1/config',
      params,
    });

    if (response?.status !== 200) {
      return Promise.reject(new Error(response?.statusText || 'Unable to fetch app config'));
    }

    const config = normalizeAppConfig(response?.data);
    if (!config) {
      return Promise.reject(new Error('Invalid app config response'));
    }

    writeCachedAppConfig(config);
    return config;
  }
);
